const generarRutaDesdeNombre = (evento) => {
  return {
    ...evento,
    ruta: '/eventos/' + evento.nombre.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''),
  };
};



// PROGRAMAMOS CUANDO SE PUBLICA LA FICHA 
const hoy = new Date(); 
const fechaPublicacion = new Date(2025, 0, 29); 




export const eventos = [
  
  //   mostrarBackend1: true,   
  //   mostrarBackend2: true,  
 //   mostrarBackend3: true,  


  {
    id: 71,
  nombre: 'Torneo NSTA KIDS',
 fecha: '08/11/2026',
    descripcion: 'Sub-6, Sub-8, Sub-10, Sub-12, Sub-14.',
    imagenUrl: '/Events/Torneo NSTA KIDS Rio Grande.jpg',
 club: 'Rio Grande',
  urlInscripcion: 'https://forms.gle/9a13ppqr9g7xHWjZ8',
mostrarBackend1: true,
  },


//  {
//     id: 70,
//   nombre: 'Torneo USISA',
//  fecha: '27/11/2026 - 29/11/2026',
//     descripcion: 'Benjamín, Alevín, Infantil, Cadete, Absoluto, Veteranos + 35 y Absoluto no federado.',
//     imagenUrl: '/Events/Torneo USISA Bellavista Huelva Club.jpg',
//   club: 'Bellavista',
//   urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSdn33Xxsv4LeeHlqtHSsSPKRioz7oWwNstu0u6Iatdn0XTZIA/viewform',
//     mostrarBackend1: true,  
//   },



 {
    id: 69,
  nombre: 'TORNEO CAJA RURAL DEL SUR',
 fecha: '23/10/2026 - 25/10/2026',
    descripcion: 'Benjamín, Alevín, Infantil, Cadete, Absoluto, Veteranos + 35 y Absoluto no federado.',
    imagenUrl: '/Events/TORNEO CAJA RURAL DEL SUR.jpg',
 club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSfWV4eg95Jn3oIx4GB_EjYGyTU8ZH8KAx3KJb94X4ABpllchw/viewform',
  
  },



 {
    id: 68,
  nombre: 'Torneo NSTA KIDS ',
 fecha: '11/10/2026',
    descripcion: 'Sub-6, Sub-8, Sub-10, Sub-12, Sub-14.',
    imagenUrl: '/Events/Torneo NSTA KIDS Domingo 11 de Octubre.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLScObTivxIMBu5vBttktA-s_q0xt1Gq2jTtQhO4LvZ7i6zZrxQ/viewform?pli=1',

  },



 {
    id: 67,
  nombre: 'Torneo Mundial Angón',
 fecha: '25/09/2026 - 27/09/2026',
    descripcion: 'Benjamín, Alevín, Infantil, Cadete, Absoluto, Veteranos + 35 y Absoluto no federado.',
    imagenUrl: '/Events/Torneo Mundial Angón.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSc1TFzocnBI7OOxL93_VnmU1m7jgNhdUTA7FpG6cvGbclQnBg/viewform',
    
  },

 {
    id: 66,
  nombre: 'SPARTAN TENIS TOUR 2026 Benjamín, Alevín, Infantil, Cadete, Junior.',
 fecha: '17/08/2026 - 23/08/2026',
    descripcion: 'SPARTAN TENIS TOUR 2026 en Bellavista. Benjamín, Alevín, Infantil, Cadete, Junior.',
    imagenUrl: '/Events/SPARTAN TENIS TOUR 2026 BELLAVISTA 2.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSc-Y-1wKrYdZ8G6eAmIWyz-5iIb62ubKxF7pX0icNt8TRZP2Q/viewform',
    
  },


 {
    id: 65,
  nombre: 'SPARTAN TENIS TOUR 2026 Absoluto, Veteranos +35 ',
 fecha: '17/08/2026 - 23/08/2026',
    descripcion: 'SPARTAN TENIS TOUR 2026 en Bellavista. Absoluto, Veteranos +35.',
    imagenUrl: '/Events/SPARTAN TENIS TOUR 2026 BELLAVISTA.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSc-Y-1wKrYdZ8G6eAmIWyz-5iIb62ubKxF7pX0icNt8TRZP2Q/viewform',
  
  },



 {
    id: 64,
  nombre: 'Torneo De Verano NSTA 2026',
 fecha: '10/07/2026 - 12/07/2026',
    descripcion: 'Torneo De Verano NSTA 2026, se celebrará los días 10, 11 y 12 de Julio en Bellavista.',
    imagenUrl: '/Events/Torneo de verano 2026.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSf68ambeEfRlYsBuMzcfTUIXrhmloWgL977ufA0SUuG1et4xA/viewform',
    
  },



 {
    id: 63,
  nombre: 'NSTA KIDS Master Final',
 fecha: '21/06/2026',
    descripcion: 'NSTA KIDS Master Final, se celebrará el dia 21 de Junio en Bellavista.',
    imagenUrl: '/Events/nsta kids master final.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSe8a2XPGaLHs0KMYNhiim6anqIf84xkusQq9-ETGZz8cLwbcQ/viewform',
    
  },





 {
    id: 62,
  nombre: 'Torneo social Club Río Grande 2026',
 fecha: '15/06/2026 - 25/06/2026',
    descripcion: 'Torneo Social Club Río Grande 2026. Del 15 al 25 de junio, compite en las categorías Absoluto y Veterano +45 (masculino y femenino) organizado por Net Sport Academy en el Club Río Grande.',
    imagenUrl: '/Events/torneo social RG 2026.jpg',
   club: 'Rio Grande',
  urlInscripcion: '', 
     
  },




 {
    id: 61,
  nombre: 'III Torneo de Tenis y Padel "Padres, Madres e Hij@s',
 fecha: '31/05/2026',
    descripcion: 'III Torneo de Tenis y Padel "Padres, Madres e Hij@s, se celebrará el dia 31 de Mayo en Bellavista.',
    imagenUrl: '/Events/V Torneo Padres, Madres.jpg',
  club: 'Bellavista',
  urlInscripcion: 'https://forms.gle/1ByXoxrqRQP9RdcZA',
     
  },



 {
    id: 60,
  nombre: 'TORNEO RELÁMPAGO ESCUELA ADULTOS',
 fecha: '31/05/2026',
    descripcion: 'Una jornada de competición, deporte y buen ambiente para disfrutar dentro y fuera de la pista. se celebrará los días 10, 11 y 12 de abril en',
    imagenUrl: '/Events/TORNEO RELÁMPAGO ESCUELA ADULTOS.jpg',
   club: 'Rio Grande',
  urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLScvQ1h9HoJAsvHu71ypviCMC6eib7wcCkzhLE318ParSjpSCQ/viewform', 
     
  },



 {
    id: 59,
  nombre: 'TORNEO DE PADEL CAJA RURAL DEL SUR',
 fecha: '18/04/2026',
    descripcion: 'Torneo de Padel Caja Rural del Sur, se celebrará el dia 18 de Abril en Bellavista.',
    imagenUrl: '/Events/Torneo de Padel Caja Rural del Sur.jpeg',
  club: 'Bellavista',
    // urlInscripcion: ' https://forms.gle/q96EBHPMy63guBJf8', // URL FORMULARIO INSCRIPCIÓN
   
  },






   {
    id: 58,
  nombre: 'TORNEO NSTA KIDS BHC (banco de alimentos)',
 fecha: '19/04/2026',
    descripcion: 'TORNEO NSTA KIDS BHC Benéfico Banco de Alimentos, se celebrará el dia 19 de Abril en Bellavista.',
    imagenUrl: '/Events/Torneo NSTA Kids Abril 2026.jpeg',
  club: 'Bellavista',
    urlInscripcion: ' https://forms.gle/q96EBHPMy63guBJf8', // URL FORMULARIO INSCRIPCIÓN
   
  },




   {
    id: 57,
  nombre: 'TORNEO BÉNEFICO (banco de alimentos)',
 fecha: '10/04/2026 - 12/04/2026',
    descripcion: 'Torneo Benéfico Banco de Alimentos, se celebrará los días 10, 11 y 12 de abril en Bellavista.',
    imagenUrl: '/Events/TORNEO BENEFICO BANCO DE ALIMENTOS.jpg',
  club: 'Bellavista',
    urlInscripcion: ' https://forms.gle/69CsdQRQUW6kGiFd7', // URL FORMULARIO INSCRIPCIÓN
   
  },


    {
    id: 56,
  nombre: 'Circuito de Huelva Future Stars',
 fecha: '22/03/2026',
    descripcion: 'Circuito de Huelva Future Stars, Domingo 22 de Marzo en Club Deportivo Pinares.',
    imagenUrl: '/Events/Circuito de Huelva Future Stars Bellavista.jpeg',
    club: 'Bellavista',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSeq_YP-2eOsFlH5TIQW3n96-2McbkGLieaPZn0fMFm3rRYmvw/viewform', // URL FORMULARIO INSCRIPCIÓN
  
  },




    {
    id: 55,
  nombre: 'Circuito de Huelva Future Stars',
 fecha: '08/03/2026',
    descripcion: 'Circuito de Huelva Future Stars, Domingo 8 de Marzo en Bellavista.',
    imagenUrl: '/Events/Circuito de Huelva Future Stars.jpeg',
    club: 'Bellavista',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLScaE8-pGpStdDOzMYzSMhLoCfaKsEgGohUyx-gFFBu1_JkPpw/viewform', // URL FORMULARIO INSCRIPCIÓN
  
  },




    {
    id: 54,
  nombre: 'IX Circuito Tenis Huelva',
 fecha: '06/03/2026 - 08/03/2026',
    descripcion: 'IX Circuito Tenis Huelva, del 6 al 8 de Marzo en Bellavista.',
    imagenUrl: '/Events/IX Circuito Tenis Huelva.jpeg',
    club: 'Bellavista',
    // urlInscripcion: ' https://forms.gle/oHHqKgxhJ3FoE4Di6', // URL FORMULARIO INSCRIPCIÓN
   
  },






    {
    id: 53,
  nombre: 'NSTA KIDS 15 Febrero Bellavista',
  fecha: '15/02/2026',
    descripcion: 'NSTA KIDS, en Bellavista Huelva Club, el 15 de Febrero.',
    imagenUrl: '/Events/NSTA KIDS BELLAVISTA ENERO 2026.jpeg',
    club: 'Bellavista',
    urlInscripcion: ' https://forms.gle/oHHqKgxhJ3FoE4Di6', // URL FORMULARIO INSCRIPCIÓN
 
  
  },




    {
    id: 52,
  nombre: 'Torneo NSTA Series 1.0, Río Grande',
  fecha: '23/01/2026 - 25/01/2026',
descripcion: 'Torneo NSTA Series 1.0, evento en Río Grande, del 23 al 25 de enero. **Suspendido por lluvia**.',
    imagenUrl: '/Events/TORNEO NSTA SERIES 1.0, 2016.jpg',
     club: 'Rio Grande',
    // urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSekFkO6_hcFeRP-XCClRzfqRcuVXhrCcDMqNsfAVMwHY74YYA/viewform', // URL FORMULARIO INSCRIPCIÓN

  },






    {
    id: 51,
  nombre: 'NSTA Kids, Evento benéfico de navidad, Río Grande',
  fecha: '18/01/2026',
    descripcion: 'NSTA Kids, Evento benéfico de navidad 2025 en Río Grande, Aplazado para el dia Domingo 18 de Enero 2026.',
    imagenUrl: '/Events/NSTA KIDS EVENTO VENEFICO DE NAVIDAD.jpg',
     club: 'Rio Grande',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSd64b7qQ6wj5fv5jQxN8LhJntIrUxGBa0PljbwOXTrVlg8vNQ/viewform', // URL FORMULARIO INSCRIPCIÓN
 
  },






  {
      
    id: 50,
  nombre: 'Torneo Otoño Bellavista 2025.jpeg',
  fecha: '29/11/2025 - 30/11/2025',
    descripcion: 'Torneo de Otoño 2025 en Bellavista Huelva Club, Sabado 14 y Domingo 30 de Noviembre.',
    imagenUrl: '/Events/Torneo Otoño Bellavista 2025.jpeg',
    club: 'Bellavista',
        urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSfcrqlhDfSn48M2KZKX6YWRynUooa0iUpLzoT5TByofKJI7og/viewform', // URL FORMULARIO INSCRIPCIÓN
 
  },



  {
      
    id: 49,
  nombre: 'NSTA Kids, Evento benéfico de navidad, Bellavista Huelva Club',
  fecha: '14/12/2025',
    descripcion: 'NSTA Kids, Evento benéfico de navidad 2025 en Bellavista Huelva Club, el 14 de Diciembre.',
    imagenUrl: '/Events/NSTA KIDS EVENTO BENÉFICO DE NAVIDAD 2025.jpg',
    club: 'Bellavista',
        urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSdeq1pIgspKin8AXkrEAPmi1Sx002EdfXzuG-bC-mz6MmIhHg/viewform', // URL FORMULARIO INSCRIPCIÓN

  },



    {
    id: 48,
  nombre: 'III Torneo Otoño 2025',
  fecha: '08/11/2025 - 09/11/2025',
    descripcion: 'III Torneo Otoño 2025 Club Río Grande, del Sabado 8 al Domingo 9 de Noviembre.',
    imagenUrl: '/Events/III Torneo Otoño 2025 Rio Grande.jpeg',
     club: 'Rio Grande',
    // urlInscripcion: 'https://docs.google.com/forms/d/1xBda3SF8QlZWe-Ui60YYpukEcpXzyX-3qnuNmNlr2OM/viewform?edit_requested=true', // URL FORMULARIO INSCRIPCIÓN

  },



  {
      
    id: 47,
  nombre: 'Torneo Usisa',
  fecha: '09/01/2026 - 11/01/2026',
    descripcion: 'Torneo Usisa en Bellavista Huelva Club, del 09 al 11 de Enero.',
    imagenUrl: '/Events/Torneo Usisa.jpeg',
    club: 'Bellavista',
        urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSc5Aqid6HmH2-NazCfGblQvhRymjHGSAU8WNwwczZ0aE7LwfA/viewform', // URL FORMULARIO INSCRIPCIÓN

  },



    {
      
    id: 46,
  nombre: 'Cardio tenis 1.0 Bellavista',
  fecha: '21/09/2025',
    descripcion: 'Cardio tenis 1.0, en Bellavista Huelva Club, el 21 Septiembre.',
    imagenUrl: '/Events/Cardio tenis 1.0.jpeg',
    club: 'Bellavista',
    
  },



    {
      
    id: 45,
  nombre: 'NSTA KIDS 5 octubre Bellavista',
  fecha: '05/10/2025',
    descripcion: 'NSTA KIDS, en Bellavista Huelva Club, el 5 octubre.',
    imagenUrl: '/Events/NSTA KIDS 5 octubre Bellavista.jpeg',
    club: 'Bellavista',
    urlInscripcion: 'https://forms.gle/WnxE8J8y6pjSHDny8', // URL FORMULARIO INSCRIPCIÓN
   
  
  },



 
    {
      
    id: 44,
  nombre: 'TORNEO MUNDIAL ANGÓN',
  fecha: '26/09/2025 - 28/09/2025',
    descripcion: 'TORNEO MUNDIAL ANGON, en Bellavista Huelva Club, del 26 de Septiembre al 28 de Septiembre.',
    imagenUrl: '/Events/Torneo Mundial Angon.jpeg',
    club: 'Bellavista',
    urlInscripcion: 'https://forms.gle/MHwEGn5Ha2dmR6Tf9', // URL FORMULARIO INSCRIPCIÓN
  
  },



    {
      
    id: 43,
  nombre: 'TORNEO SPARTAN TENNIS TOUR 2025',
  fecha: '18/08/2025 - 24/08/2025',
    descripcion: 'Torneo Spartan Tennis Tour 2025, en Bellavista Huelva Club, del 18 de Agosto al 24 de Agosto.',
    imagenUrl: '/Events/TORNEO SPARTAN TENNIS TOUR 2025.jpeg',
    club: 'Bellavista',
    urlInscripcion: 'https://forms.gle/AzytKH5QttQmEEJN7', // URL FORMULARIO INSCRIPCIÓN
 
  },

    {
    id: 42,
  nombre: 'TORNEO SPARTAN TENNIS TOUR 2025 ABSOLUTO Y VETERANOS +35',
  fecha: '18/08/2025 - 24/08/2025',
   descripcion: 'Torneo Spartan Tennis Tour 2025, Absoluto y Veteranos +35, en Bellavista Huelva Club, del 18 de Agosto al 24 de Agosto.',
    imagenUrl: '/Events/TORNEO SPARTAN TENNIS TOUR 2025   ABSOLUTO.jpeg',
    club: 'Bellavista',
    urlInscripcion: 'https://forms.gle/AzytKH5QttQmEEJN7', // URL FORMULARIO INSCRIPCIÓN
 
  },



    {
    id: 41,
  nombre: 'TORNEO VERANO BHC',
  fecha: '11/07/2025 - 13/07/2025',
    descripcion: 'TORNEO VERANO BHC, en Bellavista Huelva Club, del viernes 11 de Julio al domingo 13 de Julio.',
    imagenUrl: '/Events/CARTEL TORNEO VERANO BHC 2025.jpeg',
    club: 'Bellavista',
    urlInscripcion: ' https://forms.gle/K7XCfcv9Zv8LYrNdA', // URL FORMULARIO INSCRIPCIÓN
 
  },



    {
    id: 40,
  nombre: 'VIII Circuito Tenis Huelva ',
  fecha: '20/06/2025 - 22/06/2025',
    descripcion: 'VIII Circuito Tenis Huelva, en Bellavista Huelva Club, del viernes 20 de Junio al domingo 22 de junio.',
    imagenUrl: '/Events/8 Circuito Tenis Huelva.jpeg',
    club: 'Bellavista',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
  
  },



    {
    id: 39,
  nombre: 'Torneo Adarsa Sur',
  fecha: '18/06/2025 - 21/06/2025',
    descripcion: 'Torneo Adarsa Sur, Mercedes Pádel Tour 2025 en Bellavista Huelva Club, del miercoles 18 de Junio al sábado 21 de junio.',
    imagenUrl: '/Events/torneo adarsa sur 2020.jpeg',
    club: 'Bellavista',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
 
  },



    {
    id: 38,
  nombre: 'Torneo Social Club Río Grande',
  fecha: '23/06/2025 - 28/06/2025',
    descripcion: 'Torneo Social del Club Río Grande, del lunes 23 al sábado 28 de junio.',
    imagenUrl: '/Events/Torneo Social Club Río Grande.jpeg',
     club: 'Rio Grande',
    urlInscripcion: 'https://forms.gle/bgfAmnGUMpRcWzBJ7', // URL FORMULARIO INSCRIPCIÓN

  },







    {
    id: 37,
  nombre: 'Torneo NSTA Kids Rio Grande',
    fecha: '14/06/2025',
    descripcion: 'Torneo NSTA Kids en Rio Grande el próximo Sabado 14 de Junio.',
    imagenUrl: '/Events/NSTA Kids Rio Grande Junio 2025.jpeg',
     club: 'Rio Grande',
    urlInscripcion: ' https://forms.gle/ai8FnB8ogH7t8eoq5', // URL FORMULARIO INSCRIPCIÓN
   
  },


 
  {
    id: 36,
    nombre: 'Torneo NSTA Kids Bellavista Huelva Club',
    fecha: '25/05/2025',
    descripcion: 'Torneo NSTA Kids en Bellavista Huelva Club el próximo Sabado 25 de Mayo.',
    imagenUrl: '/Events/NSTA KIDS Mayo 2025 Bellavista.jpg',
    club: 'Bellavista',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLScZM6USmByB8Yxgdl2SZNGM2baHt_zU4FfAUxdJW4FN7F9mFg/viewform', // URL FORMULARIO INSCRIPCIÓN
  
  },



  {
    id: 35,
    nombre: 'Torneo Primavera Airbus',
    fecha: '25/04/2025 - 27/04/2025',
    descripcion: 'Torneo Primavera Airbus el próximo 25, 26 y 27 de Abril.',  
    imagenUrl: '/Events/Torneo Primavera Airbus.jpg',
    club: 'Airbus',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN  
   
  },

  


  {
    id: 34,
    nombre: 'Torneo NSTA Kids Rio Grande',
    fecha: '06/04/2025',
    descripcion: 'Torneo NSTA Kids en Rio Grande el próximo Domingo 6 de Abril.',  
    imagenUrl: '/Events/Torneo Nsta Kids Abril 2025.jpeg',
    club: 'Rio Grande',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSetwKuyWEWXJUeniB_8Pne63B4KNXVzxaFtsRZUPGZol-ebpw/viewform', // URL FORMULARIO INSCRIPCIÓN
  
   
  },




  {
    id: 33,
    nombre: 'Torneo NSTA Kids Rio Grande',
    fecha: '16/03/2025',
    descripcion: 'Torneo NSTA Kids en Rio Grande el próximo Domingo 16 de Marzo.',  
    imagenUrl: '/Events/NSTA Kids Rio Grande Marzo 2025.jpeg',
    club: 'Rio Grande',
    urlInscripcion: 'https://forms.gle/Fxyvtcnyaf1wg79A7', // URL FORMULARIO INSCRIPCIÓN
  
   
  },



  {
    id: 32,
    nombre: 'V torneo, padres, madres e hij@s',
    fecha: '22/03/2025',
    descripcion: 'V torneo, padres, madres e hij@s el próximo Sábado 22 de Marzo.',
    imagenUrl: '/Events/V torneo, padres, madres e hij@s.jpeg',
    club: 'Rio Grande',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
  
  },



  {
    id: 31,
    nombre: 'Clínic De Padel Bellavista Huelva Club',
    fecha: '22/02/2025',
    descripcion: 'Clínic De Padel en el club Bellavista Huelva Club el próximo Sábado 22 de Febrero.',
    imagenUrl: '/Events/Bellavista - Clinic de pade.jpeg',
    club: 'Bellavista',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
  },

  {
    id: 30,
    nombre: 'II Torneo Palomares Pádel Club',
    fecha: '15/02/2025',
    descripcion: 'II Torneo Palomares Pádel Club el próximo Sábado 15 de Febrero.',
    imagenUrl: '/Events/II Torneo Palomares 2024.jpeg',
    club: 'Palomares',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
  },




  {
    id: 29,
    nombre: 'Cardio Tenis 2.0',
    fecha: '02/02/2025',
    descripcion: 'Cardio Tenis 2.0 en Rio Grande el próximo Domingo 2 de Febrero.',
    imagenUrl: '/Events/Cardio Tenis 2.0.jpeg',
    club: 'Rio Grande',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN

  },





  {
    id: 28,
    nombre: 'Torneo NSTA Kids Bellavista Huelva Club',
    fecha: '09/02/2025',
    descripcion: 'Torneo NSTA Kids en Bellavista Huelva Club el próximo Domingo 9 de Febrero.',
    imagenUrl: '/Events/Torneo Nsta Kids Febrero 2025 .jpeg',
    club: 'Bellavista',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
  
  },




  {
    id: 27,
    nombre: 'Torneo federado nsta series 1.0',
    fecha: '24/01/2025 - 26/01/2025',
    descripcion: 'Torneo federado NSTA Series 1.0. Del Viernes 24 al Domingo 26 de Enero.',
    imagenUrl: '/Events/Torneo federado nsta series 1.0.jpeg',
    club: 'Rio Grande',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSf7wTSuCX5wsMCvivXsYfq42VGjtRetxWgWfYsGJEGpJmvXrw/viewform', // URL FORMULARIO INSCRIPCIÓN
  
  },




  {
    id: 26,
    nombre: 'Torneo NSTA Kids Rio Grande',
    fecha: '15/12/2024',
    descripcion: 'Torneo Beneféfico de Navidad en Rio Grande, dona un regalo a los niñ@s mas necesitados. Domingo 15 de Diciembre.',
    imagenUrl: '/Events/Torneo Beneféfico de Navidad en Rio Grande.jpg',
    club: 'Rio Grande',
    urlInscripcion: '', // URL FORMULARIO INSCRIPCIÓN
   
  },


  {
    id: 24,
    nombre: 'Torneo Otoño Rio Grande',
    fecha: '30/11/2024 - 01/12/2024',
    descripcion: 'Torneo Otoño Rio Grande Sabado 30 de Noviembre y Domingo 1 de Diciembre.',
    imagenUrl: '/Events/Torneo Otoño Rio Grande.jpg',
    club: 'Rio Grande',
    urlInscripcion: '',      //INSCRIPCIÓN
  },

  {
    id: 23,
    nombre: 'Torneo NSTA Kids Bellavista Huelva Club',
    fecha: '10/11/2024',
    descripcion: 'Torneo NSTA Kids Bellavista Huelva Club, día Domingo 10 de Noviembre del 2024.',
    imagenUrl: '/Events/Torneo NSTA Kids Bellavista Huelva Club.jpeg',
    club: 'Bellavista',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 22,
    nombre: 'Torneo NSTA Kids Rio Grande',
    fecha: '01/11/2024',
    descripcion: 'Torneo NSTA Kids en Rio Grande el 1 de Noviembre del 2024.',
    imagenUrl: '/Events/Torneo NSTA Kids Rio Grande.jpeg',
    club: 'Rio Grande',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 21,
    nombre: 'Quedada Halloween',
    fecha: '01/11/2024',
    descripcion: 'Quedada Halloween en G.E Airbus.',
    imagenUrl: '/Events/HalloweenAirbus.jpeg',
    club: 'Airbus',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 20,
    nombre: 'Super quedada Halloween',
    fecha: '01/11/2024',
    descripcion: 'Super quedada Halloween en Palomares.',
    club: 'Palomares',
    imagenUrl: '/Events/HallowenPalomares.jpeg',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 19,
    nombre: 'Torneo NSTA Series 1.0',
    fecha: '11/10/2024 - 13/10/2024',
    descripcion: 'Torneo NSTA Series 1.0 Bellavista Huelva Club!',
    imagenUrl: '/Events/TORNEO NSTA SERIES 1.0.jpg',
    club: 'Bellavista',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 18,
    nombre: 'Torneo Social Club Rio Grande 2024',
    fecha: '30/09/2024 - 05/10/2024',
    descripcion: 'Torneo Social Club Rio Grande, Categorías: Absoluto Masculino y Femenino Veterano + 45 Masculino',
    imagenUrl: '/Events/Torneo Social Club Rio Grande.jpg',
    club: 'Rio Grande',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 17,
    nombre: 'Spartan Adultos Tenis Tour 2024',
    fecha: '19/08/2024 - 25/08/2024',
    descripcion: 'Spartan Adultos Tenis Tour 2024 del 19 de Agosto al 25 de Agosto. Categorías Absoluto y +35.',
    imagenUrl: '/Events/spartanAbsoluto2024.jpg',
    club: 'Bellavista',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 16,
    nombre: 'Spartan Tenis Tour 2024',
    fecha: '19/08/2024 - 25/08/2024',
    descripcion: 'Spartan Tenis Tour 2024 del 19 de Agosto al 25 de Agosto.',
    imagenUrl: '/Events/spartan2024.jpg',
    club: 'Bellavista',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 15,
    nombre: 'Torneo de Verano Bellavista Huelva Club',
    fecha: '12/07/2024 - 14/07/2024',
    descripcion: 'Torneo de verano los días 12, 13 y 14 de Julio en Bellavista Huelva Club.',
    imagenUrl: '/Events/Torneo de verano en Bellavista Huelva Club.jpg',
    club: 'Bellavista',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 14,
    nombre: 'Torneo Federado Bellavista Huelva Club',
    fecha: '05/07/2024 - 07/07/2024',
    descripcion: 'Torneo Federado en Bellavista Huelva Club del 5 de Julio al 7 de Julio 2024.',
    imagenUrl: '/Events/Torneo Federado Bellavista Huelva Club.jpg',
    club: 'Bellavista',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 13,
    nombre: 'Torneo Benéfico para la investigación de la Ataxia Telangiectasia',
    fecha: '29/06/2024 - 30/06/2024',
    descripcion: 'Torneo Benéfico para la investigación de la Ataxia Telangiectasia',
    imagenUrl: '/Events/Torneo Benéfico para la investigación de la Ataxia Telangiectasia.jpeg',
    club: 'Airbus',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 12,
    nombre: 'Torneo Nocturno',
    fecha: '28/06/2024',
    descripcion: 'Torneo Nocturno Viernes 28 de Junio.',
    imagenUrl: '/Events/Torneo Nocturno.jpeg',
    club: 'Palomares',

    urlInscripcion: '', // FORMULARIO
  },




  {
    id: 11,
    nombre: 'Torneo Dobles NSTA',
    fecha: '1/05/2024',
    descripcion: 'Torneo Dobles NSTA en Club Rio Grande.',
    imagenUrl: '/Events/TORNEO-DOBLES-NSTA.jpg',
    club: 'Rio Grande',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 10,
    nombre: 'Circuito TWE en Río Grande',
    fecha: '26/04/2024 - 28/04/2024',
    descripcion: 'Continuamos con el 2º Circuito Tennis Warehouse Europe con la celebración del 3er torneo en las magníficas instalaciones de la Asociación Recreativa Río Grande.',
    imagenUrl: '/Events/CircuitoTW.jpg',
    club: 'Rio Grande',
    urlInscripcion: 'https://docs.google.com/forms/d/e/1FAIpQLSd1YV3W3lkakI1Wnmf7swVSEF5kThUity6q-FpxtjHXVP9mAg/viewform?vc=0&c=0&w=1&flr=0', // FORMULARIO
  },

  {
    id: 9,
    nombre: 'III Torneo NSTA Kids',
    fecha: '28/04/2024',
    descripcion: 'Este evento de carácter recreativo, esta dedicado a las edades comprendidas entre los 4 y los 12 años. El objetivo es adentrar a los más pequeños en la competición, que den sus primeros pasos en la misma, que aprendan las reglas de juego básicas, hagan nuevas amistades y fundamentalmente que se enamoren del tenis.',
    imagenUrl: '/Events/3torneonstakids.jpg',
    club: 'Bellavista',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 8,
    nombre: 'Torneo de padel Mucopolisacaridosis',
    fecha: '04/05/2024',
    descripcion: 'Torneo de padel solidario por la Mucopolisacaridosis.',
    imagenUrl: '/Events/mucopolisacaridosis.jpg',
    club: 'Palomares',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 7,
    nombre: 'Campus Semana Santa en G.E Airbus',
    fecha: '25/03/2024 - 27/03/2024',
    descripcion: 'Campus Semana Santa los dias 25, 26, y 27 de Marzo en G.E Airbus.',
    imagenUrl: '/Events/campus semana santa AIRBUS.jpg',
    club: 'Airbus',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 6,
    nombre: 'Torneo de Pádel en Palomares Pádel Club y en Bellavista Huelva Club',
    fecha: '08/06/2024',
    descripcion: 'Torneo de Pádel en Palomares Pádel Club y en Bellavista Huelva Club, ida 27/04/2024 vuelta 08/06/2024.',
    imagenUrl: '/Events/Torneo de Pádel en Palomares Pádel Club y en Bellavista Huelva Club.jpg',
    club: 'Palomares',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 5,
    nombre: 'Intensivo Competición Semana Santa',
    fecha: '25/03/2024 - 27/03/2024',
    descripcion: 'Intensivo Competición Semana Santa los dias 25, 26 y 27 de Marzo en Club Rio Grande.',
    imagenUrl: '/Events/Intensivo Competición Semana Santa.jpg',
    club: 'Rio Grande',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 4,
    nombre: 'Campeonato de Andalucía Alevín y Cadete Fase Provincial Huelva',
    fecha: '07/03/2024 - 10/03/2024',
    descripcion: 'La fase provincial del Campeonato de Andalucía, en las categorías Alevín y Cadete, se celebrará en el Bellavista Huelva Club. Este evento deportivo reunirá a los jóvenes talentos del tenis, quienes competirán por avanzar a la siguiente etapa del campeonato regional.',
    imagenUrl: '/Events/CAMPEONATO DE ANDALUCIA ALEVIN Y CADETE.jpg',
    club: 'Bellavista',
    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 3,
    nombre: '7º circuito tenis de Huelva',
    fecha: '01/03/2024 - 03/03/2024',
    descripcion: 'El torneo federado se celebrará del viernes 1 al domingo 3 de marzo, como parte del 7º circuito de tenis de Huelva.',
    imagenUrl: '/Events/7º circuito tenis de Huelva.jpg',
    club: 'Bellavista',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 2,
    nombre: 'NSTA Family',
    fecha: '28/02/2024',
    descripcion: 'Es uno de los últimos eventos diseñados por NSTA con el objetivo de disfrutar del tenis en familia. Consiste en una jornada de clases de tenis dirigidas a todo el núcleo familiar, donde comparten la misma clase mama, papa, hij@s, abuelos, tíos, primos, etc.',
    imagenUrl: '/Events/NSTAFAMILY.jpg',
    club: 'Rio Grande',

    urlInscripcion: '', // FORMULARIO
  },

  {
    id: 1,
    nombre: 'NSTA Kids',
    fecha: '03/03/2024',
    descripcion: 'Este evento de carácter recreativo, esta dedicado a las edades comprendidas entre los 4 y los 12 años. El objetivo es adentrar a los más pequeños en la competición, que den sus primeros pasos en la misma.',
    imagenUrl: '/Events/TorneoNSTAKidsRosa.jpg',
    club: 'Rio Grande',

    urlInscripcion: '', // FORMULARIO
  },

]



.filter(evento => evento.id !== 29 || hoy >= fechaPublicacion) // PROGRAMAMOS QUE FICHA ES LA QUE SE PUBLICA CON EL DIA INDICADO


.map(generarRutaDesdeNombre);